import React from "react";
import { IconProps, SvgIcon } from "@mui/material";

interface IAppSidePanelIconProps extends IconProps {
    right?: boolean;
}

export const AppSidePanelIcon = (props: IAppSidePanelIconProps) => {
    return (
        <SvgIcon
            viewBox="0 0 64 64"
            style={{ transform: props.right ? "rotate(180deg)" : undefined }}
        >
            <path style={{ fill: "none" }} d="M0-64h1280v800H0z"/>
            <path d="M50.01 56.074H14.021a5.997 5.997 0 0 1-5.995-5.995V14.068a5.997 5.997 0 0 1 5.995-5.994H50.01a5.997 5.997 0 0 1 5.995 5.994v36.011a5.997 5.997 0 0 1-5.995 5.995zM49.017 12.074H28.026v40h20.991a2.99 2.99 0 0 0 2.989-2.989V15.063a2.99 2.99 0 0 0-2.989-2.989z" fill="currentColor" stroke="none"/>
        </SvgIcon>
    );
};